export const STRAPI_CONFIG = {
  API_BASE: process.env.STRAPI_API_URL || "https://passionate-chickens-6c92b506f3.strapiapp.com/api"
};
